import React, { useState, useEffect } from 'react';
import { SectionHeader } from '../components/site/SectionHeader';
import { SEOHead } from '../components/site/SEOHead';
import api, { getFileUrl } from '../lib/api';

export default function Corporate() {
  const [data, setData] = useState(null);
  const [seo, setSeo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/settings/corporate'),
      api.get('/seo/corporate')
    ]).then(([d, s]) => {
      setData(d.data);
      setSeo(s.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div data-testid="corporate-page">
      <SEOHead title={seo.title} description={seo.description} keywords={seo.keywords} />
      
      {/* Hero Banner */}
      <div className="relative py-16 md:py-24 bg-[#0f1419]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            Kurumsal
          </h1>
          <div className="mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))]" />
        </div>
      </div>

      {/* About Section */}
      <section className="py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
            <div className="md:col-span-7">
              <SectionHeader title={data?.about_title || 'Hakkımızda'} />
              <p className="text-sm md:text-base leading-relaxed text-muted-foreground whitespace-pre-line">
                {data?.about_text}
              </p>
            </div>
            <div className="md:col-span-5">
              <div className="rounded-2xl overflow-hidden shadow-[var(--shadow-elev-2)] border border-[hsl(var(--gold)/0.2)]">
                <img
                  src={data?.image_path ? getFileUrl(data.image_path) : 'https://images.pexels.com/photos/8961133/pexels-photo-8961133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'}
                  alt="Kurumsal"
                  className="w-full aspect-[4/3] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-14 md:py-20 bg-secondary">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {/* Mission */}
            <div className="p-6 md:p-8 rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)]">
              <div className="w-12 h-12 rounded-xl bg-[hsl(var(--gold)/0.1)] flex items-center justify-center mb-4">
                <span className="font-heading text-xl font-bold text-[hsl(var(--gold))]">M</span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-semibold mb-3">{data?.mission_title || 'Misyon'}</h3>
              <p className="text-sm md:text-base leading-relaxed text-muted-foreground whitespace-pre-line">
                {data?.mission_text}
              </p>
            </div>

            {/* Vision */}
            <div className="p-6 md:p-8 rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)]">
              <div className="w-12 h-12 rounded-xl bg-[hsl(var(--gold)/0.1)] flex items-center justify-center mb-4">
                <span className="font-heading text-xl font-bold text-[hsl(var(--gold))]">V</span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-semibold mb-3">{data?.vision_title || 'Vizyon'}</h3>
              <p className="text-sm md:text-base leading-relaxed text-muted-foreground whitespace-pre-line">
                {data?.vision_text}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
